var map = {
	"./de/btn-back.png": "VlkO",
	"./en/btn-back.png": "rnOL",
	"./es/btn-back.png": "KOEt",
	"./fr/btn-back.png": "FT28",
	"./ja/btn-back.png": "BfrZ",
	"./ko/btn-back.png": "WHq9",
	"./pt/btn-back.png": "Q5UG",
	"./ru/btn-back.png": "vH1S",
	"./th/btn-back.png": "2/sa",
	"./zh-Hant/btn-back.png": "0xgh"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "HmMQ";